import { FormControl } from "@angular/forms";
import { AgFilterComponent } from "@ag-grid-community/angular";
import { IDoesFilterPassParams, IFilterParams } from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-boolean-filter",
  templateUrl: "./boolean-filter.component.html",
  styleUrls: ["./boolean-filter.component.scss"],
})
export class BooleanFilterComponent implements AgFilterComponent, OnDestroy {
  params: IFilterParams;
  value: string = "all";
  formControl: FormControl = new FormControl("all");
  private destroy$ = new Subject<void>();

  agInit(params: IFilterParams): void {
    this.params = params;

    this.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.value = e;
      this.params.filterChangedCallback();
    });
  }

  isFilterActive(): boolean {
    if (this.params.colDef.colId == "Active") {
      if (this.value == null) {
        this.value = "true";
        this.formControl.setValue(this.value);
        return true;
      } else return this.value !== "true";
    } else {
      if (this.value == null) {
        this.value = "all";
        this.formControl.setValue(this.value);
        return true;
      } else return this.value !== "all";
    }
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    return true;
  }

  getModel() {
    if (this.value !== "all") {
      return {
        filterType: "boolean",
        value: this.value == "true",
      };
    } else {
      return null;
    }
  }

  setModel(model: any) {
    this.value = model;
    this.formControl.setValue(model);
  }

  updateFilter() {
    this.params.filterChangedCallback();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
